import React from 'react';
import { FiCheck } from 'react-icons/fi';
import { WIZARD_STEPS } from '../pages/printableMapConstants';
import '../pages/printable-map-shell.css';

export function PrintableMapStepper({ step }) {
  return (
    <div
      className="pm-stepper"
      role="progressbar"
      aria-valuemin={1}
      aria-valuemax={WIZARD_STEPS.length}
      aria-valuenow={step}
      aria-label={`Printable map step ${step} of ${WIZARD_STEPS.length}: ${WIZARD_STEPS[step - 1]}`}
    >
      {WIZARD_STEPS.map((label, index) => {
        const stepNumber = index + 1;
        const done = step > stepNumber;
        const current = step === stepNumber;
        const active = done || current;

        return (
          <div key={label} className="pm-stepper__item">
            <div className="pm-stepper__track">
              <div
                className={[
                  'pm-stepper__line',
                  'pm-stepper__line--left',
                  index === 0 ? 'pm-stepper__line--hidden' : '',
                  step >= stepNumber ? 'is-complete' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              />
              <div
                className={[
                  'pm-stepper__circle',
                  active ? 'is-active' : '',
                  current ? 'is-current' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              >
                {done ? (
                  <FiCheck aria-hidden="true" />
                ) : (
                  <span>{String(stepNumber).padStart(2, '0')}</span>
                )}
              </div>
              <div
                className={[
                  'pm-stepper__line',
                  'pm-stepper__line--right',
                  index === WIZARD_STEPS.length - 1 ? 'pm-stepper__line--hidden' : '',
                  step > stepNumber ? 'is-complete' : '',
                ]
                  .filter(Boolean)
                  .join(' ')}
              />
            </div>
            <div
              className={[
                'pm-stepper__label',
                active ? 'is-active' : '',
              ].join(' ')}
            >
              {label}
            </div>
          </div>
        );
      })}
    </div>
  );
}
